import Swiper from "swiper";
import { addToGlobalThisRet, findControls } from "@plugins";

function initMentionedProductsSlider() {
    const mentionedProducts = document.querySelector(".js-mentioned-products");

    if (mentionedProducts) {
        const sliderContainer = mentionedProducts.querySelector(".js-mentioned-products-slider");
        const controls = findControls(mentionedProducts, ".js-mentioned-products-controls");

        new Swiper(sliderContainer, {
            slidesPerView: 1.9,
            spaceBetween: 16,
            pagination: {
                el: controls.pagination,
                type: "progressbar",
            },
            navigation: {
                prevEl: controls.buttonPrev,
                nextEl: controls.buttonNext,
            },
            observer: true,
            observeParents: true,
            breakpoints: {
                406: {
                    slidesPerView: 1.9,
                    spaceBetween: 16,
                },
                567: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
                768: {
                    shortSwipes: false,
                    slidesPerView: 3,
                },
                992: {
                    shortSwipes: false,
                    slidesPerView: 4,
                    spaceBetween: 0,
                },
            },
        });
    }
}

window.addEventListener("load", () => {
    initMentionedProductsSlider();
});

// Записываем в глобальный подобъект для бэка
addToGlobalThisRet(initMentionedProductsSlider, "initMentionedProductsSlider");
